import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import { deleteSettingProject } from "Stores/actions/properties/ShopAction";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import * as Icons from "react-bootstrap-icons";

export default function DeleteProjects({ row }) {
  const [showAlert, setShowAlert] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { selectedProject } = useSelector((state) => ({
    selectedProject: state.shop.selectedProject,
  }));

  const onShowAlert = () => {
    setShowAlert(!showAlert);
  };

  const onDelete = async () => {
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: +row.Id,
      };
      setLoading(true);
      await dispatch(
        deleteSettingProject(data, selectedProject.Id === +row.Id),
      );
      onShowAlert();
      setLoading(false);
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={!read("settingShopProject")?.accessDelete}
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id="relationAlert" />}
        loading={loading}
      />{" "}
    </>
  );
}
